module.exports = __webpack_public_path__ + "img/commissionConfig.e33b0540.svg";